import { Metamodel } from 'app/model/base/model';
import { StoreWriteSettings } from './store-write-settings';
import { FileServerLinkedService } from 'app/model/linkedservice/file-server.linkedservice';

@Metamodel.model({
    name: 'FileServerWriteSettings',
    tags: {
        linkedServiceModel: Metamodel.modelFor(FileServerLinkedService)
    }
})

export class FileServerStoreWriteSettings extends StoreWriteSettings {
}
